import {
  Alert,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import "../Auth.css";
import "./Login.css";
import { useEffect, useState } from "react";
import { useAuth } from "../../../context/AuthContext/AuthContext";
import api from "../../../api/axiosInstance";

const Login = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [errorMsg, setErrorMsg] = useState<string>("");
  const { login, isAuthenticated } = useAuth();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setErrorMsg("");
    try {
      const response = await api.post("Auth/login", {
        email,
        password,
      });
      login(response.data.data.token);
    } catch (error: any) {
      const msg =
        error.response?.data?.message ||
        "Authentication failed. Please check your credentials.";
      setErrorMsg(msg);
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/blog");
    }
  }, [isAuthenticated, navigate]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#F5F5F5",
      }}
    >
      <Card
        sx={{
          width: 400,
          p: 2,
        }}
      >
        <form onSubmit={handleSubmit}>
          <CardContent>
            <Typography variant="h5" sx={{ mb: 2 }}>
              ავტორიზაცია
            </Typography>

            {/* <Typography sx={{ mb: 2 }}>
              <Link component={RouterLink} to={"/register"} underline="hover">
                შექმენი ანგარიში
              </Link>
            </Typography> */}

            {errorMsg && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {errorMsg}
              </Alert>
            )}

            <TextField
              label="მეილი"
              type="email"
              variant="outlined"
              fullWidth
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <TextField
              label="პაროლი"
              type="password"
              variant="outlined"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <CardActions sx={{ justifyContent: "flex-end", p: 2 }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
              >
                შესვლა
              </Button>
            </CardActions>
          </CardContent>
        </form>
      </Card>
    </Box>
  );
};

export default Login;
